<ng-container *ngIf="useLottieAnimation; else defaultLoader">
	<lottie-animation
		[path]="lottiePath"
		[staticFrame]="false"
		[loop]="true"
		[autoplay]="true"
	></lottie-animation>
</ng-container>

<ng-template #defaultLoader>
	<div class="legacy-ring inside">
		<div class="row">
			<span class="cell"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell"></span>
		</div>
		<div class="row">
			<span class="cell filled"></span>
			<span class="cell"></span>
			<span class="cell"></span>
			<span class="cell filled"></span>
		</div>
		<div class="row">
			<span class="cell filled"></span>
			<span class="cell"></span>
			<span class="cell"></span>
			<span class="cell filled"></span>
		</div>
		<div class="row">
			<span class="cell"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell"></span>
		</div>
	</div>

	<div class="legacy-ring outside">
		<div class="row">
			<span class="cell"></span>
			<span class="cell"></span>
			<span class="cell"></span>
			<span class="cell"></span>
		</div>
		<div class="row">
			<span class="cell"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell"></span>
		</div>
		<div class="row">
			<span class="cell"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell"></span>
		</div>
		<div class="row">
			<span class="cell"></span>
			<span class="cell"></span>
			<span class="cell"></span>
			<span class="cell"></span>
		</div>
	</div>
</ng-template>
